import axios from '@/utils/api'

const state = {
}

const getters = {
}
const actions = {
  async finalizarCadastroRf ({ commit }, cadastro) {
    return axios({
      method: 'post',
      data: cadastro,
      url: 'cadastro-rf/finalizar'
    })
  },
  async salvarCadastroRf ({ commit }, cadastro) {
    return axios({
      method: 'post',
      data: cadastro,
      url: 'cadastro-rf/salvar'
    })
  },
  async cadastroRfNovo ({ commit }, emptyRf) {
    return axios({
      method: 'post',
      data: emptyRf,
      url: 'cadastro-rf/criar-novo'
    })
  },
  async cadastroRfById ({ commit }, id) {
    return axios({
      method: 'get',
      url: `cadastro-rf/byId/${id}`
    })
  },
  async getCadastrosRf ({ commit }, pagina) {
    return axios({
      method: 'get',
      url: `cadastro-rf/listar?page=${pagina}`
    })
  },

  async getJsonRf ({ commit }, protocolo) {
    try {
      const data = await axios({
        method: 'get',
        url: `cadastro-rf/getJson/${protocolo}`
      })
      return data
    } catch (e) {
      console.error('Erro ao cadastrar', e)
    }
  }
}
const mutations = {
}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/analise/cadastroRf.js